@if (printerFormService.printerFormReady() && printer) {
    <form autocomplete="off" [formGroup]="printerGroupForm" class="tw-contents">
        <app-card
            [fullWidth]="true"
            [withCard]="true"
            [cardTitle]="'FIDELITY.SETUP.CAMPAIGNS.GENERAL_SECTION' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-px-1">
                <div class="tw-col-span-12 lg:tw-col-span-6">
                    <mat-slide-toggle [formControl]="printerFormService.splitStubsByCategory!" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SPLIT_STUBS_BY_CATEGORY' | translate}}</span>
                    </mat-slide-toggle>
                </div>

                <div class="tw-col-span-12 lg:tw-col-span-6">
                    <mat-slide-toggle [formControl]="printerFormService.printOtherCategories!" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.PRINT_OTHER_CATEGORIES' | translate}}</span>
                    </mat-slide-toggle>
                </div>
            </section>
        </app-card>

        <app-card
            [fullWidth]="true"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.CATEGORIES' | translate : {printer: printer}"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-3 tw-items-center tw-px-1"
                formGroupName="categoriesForm">
                <div class="tw-p-2">
                    <span [class]="subTitleClass">
                        {{'PRINTERS.DETAIL.ENABLE_CATEGORIES' | translate : {printer: printer} }}
                    </span>
                </div>
                <div>
                    <mat-checkbox [formControl]="printerFormService.allCategories" (change)="toggleAllCategories()">
                        {{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}
                    </mat-checkbox>
                    <!-- <mat-slide-toggle [formControl]="printerFormService.allCategories" (change)="toggleAllCategories()" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SELECT_ALL' | translate }}</span>
                    </mat-slide-toggle> -->
                </div>

                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4 tw-items-center" 
                    formArrayName="categories">
                    @for(category of printerFormService.categoriesArray.controls; track i; let i = $index) {
                        <div [formGroupName]="i">
                            <mat-checkbox formControlName="checked" (change)="onSingleCategoryChange()">
                                {{ category.get('name')?.value }}
                            </mat-checkbox>
                            <!-- <mat-slide-toggle formControlName="checked" (change)="onSingleCategoryChange()" class="tw-flex tw-p-3">
                                <span class="tw-flex tw-ml-2">{{ category.get('name')?.value }}</span>
                            </mat-slide-toggle> -->
                        </div>
                    }
                </div>
    
            </section>
        </app-card>
    </form>
}